export default __webpack_public_path__ + "static/media/aws_infra_icon.0acedc98.svg";